import { AccountsCard } from '../../core/entities/general/AccountsCard.entity';
import { BalanceAccountChart } from '../../core/entities/general/BalanceAccountChart.entity';
import { BalanceBankChart } from '../../core/entities/general/BalanceBankChart.entity';
import { BalanceCard } from '../../core/entities/general/BalanceCard.entity';
import { GeneralGroupData } from '../../core/entities/general/GeneralGroupData.entity';
import {
  BalanceCardResponse,
  BalanceChartResponse,
  InfoCardResponse,
  MainBoardResponse,
} from '../interfaces/main-board.interface';

export class GeneralDataMapper {
  static fromResponseToEntity(response: MainBoardResponse): GeneralGroupData {
    return new GeneralGroupData(
      this.fromBalanceCardResponseToEntity(response.balanceCard),
      this.fromInfoCardResponseToEntity(response.infoCard),
      this.fromBalanceBankChartResponseToEntity(response.balanceBankChart),
      this.fromBalanceAccountTypeChartResponseToEntity(
        response.balanceAccountTypeChart
      )
    );
  }

  static fromBalanceCardResponseToEntity(
    response: BalanceCardResponse
  ): BalanceCard {
    return new BalanceCard(
      response.updateDate,
      response.balance,
      response.variation
    );
  }

  static fromInfoCardResponseToEntity(
    response: InfoCardResponse
  ): AccountsCard {
    return new AccountsCard(
      response.banks,
      response.accounts,
      response.monthTransactions
    );
  }

  static fromBalanceBankChartResponseToEntity(
    response: BalanceChartResponse[]
  ): BalanceBankChart[] {
    return response.map(
      (item) =>
        new BalanceBankChart(
          item.bank ?? '',
          item.date,
          item.balance,
          item.percentage
        )
    );
  }

  static fromBalanceAccountTypeChartResponseToEntity(
    response: BalanceChartResponse[]
  ): BalanceAccountChart[] {
    return response.map(
      (item) =>
        new BalanceAccountChart(
          item.accountType ?? '',
          item.date,
          item.balance,
          item.percentage
        )
    );
  }
}
